<template>
  <div class="customer-baseinfo">
    <!--企业基本信息-->
    <h3>企业基本信息</h3>
    <div class="edit-btns margin-bottom-20 ">
      <a-button type="primary" @click="_exportClient">客户信息导出</a-button>
      <a-button
        slot="extra"
        type="primary"
        size="default"
        @click="editBasic"
        class="margin-left-20"
        v-if="permissions && permissions.includes('编辑')"
      >
        编辑
      </a-button>
    </div>
    <CardEdit
      ref="formBasic"
      formName="formBasic"
      :source-data="sourceDataBasic"
      :schema="BASIC_INFO_SCHEMA"
      layout="horizontal"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      :defaultColLg="12"
      :defaultColMd="24"
      @handleBusiTypeChange="value => handleBusiTypeChange(value, 'formBasic')"
    >
      <!-- 联动select，具名插槽 -->
      <template v-slot:region="slotProps">
        <a-select
          :disabled="slotProps.item.disabled"
          :placeholder="slotProps.item.placeholder || '请选择'"
          v-decorator="[
            slotProps.item.key,
            {
              initialValue: slotProps.item.value,
              rules: slotProps.item.rules,
            },
          ]"
        >
          <a-select-option
            v-for="optionItem in regionOptionList"
            :value="optionItem.id"
            :key="optionItem.id"
            :disabled="optionItem.disabled"
          >
            {{ optionItem.name }}
          </a-select-option>
        </a-select>
      </template>
      <!-- 业务模式 -->
      <template v-slot:model="slotProps">
        <a-select
          :disabled="slotProps.item.disabled"
          :placeholder="slotProps.item.placeholder || '请选择'"
          v-decorator="[
            slotProps.item.key,
            {
              initialValue: slotProps.item.value,
              rules: slotProps.item.rules,
            },
          ]"
          @focus="handleModelFocus"
        >
          <a-select-option
            v-for="optionItem in modelOptionList"
            :value="optionItem.id"
            :key="optionItem.id"
            :disabled="optionItem.disabled"
          >
            {{ optionItem.name }}
          </a-select-option>
        </a-select>
      </template>

      <!-- 业务类型 -->
      <template v-slot:business="slotProps">
        <a-select
          :disabled="slotProps.item.disabled"
          :placeholder="slotProps.item.placeholder || '请选择'"
          v-decorator="[
            slotProps.item.key,
            {
              initialValue: slotProps.item.value,
              rules: slotProps.item.rules,
            },
          ]"
          @focus="handleBgFocus"
          @change="changeBusiType"
        >
          <a-select-option
            v-for="optionItem in businessList"
            :value="optionItem.id"
            :key="optionItem.id"
            :disabled="optionItem.disabled"
          >
            {{ optionItem.name }}
          </a-select-option>
        </a-select>
      </template>

      <!-- 操作区域 -->

      <template v-slot:operate-area>
        <div v-show="basicButtonsShow" style="text-align:right">
          <a-button type="" @click="handleCancelBasic">
            取消
          </a-button>
          <a-button
            type="primary"
            class="margin-left-20"
            @click="handleSubmitBasic"
          >
            保存
          </a-button>
        </div>
      </template>
    </CardEdit>
  </div>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
//import ExtraInfo from './ExtraInfo'
import { SCORE_CARD_SCHEMA } from '@/utils/staticData.js'
import mixin from './mixin.js'
import {
  addCuntomer,
  getBusinessList,
  getListCManager,
  exportClient,
  getRegionList,
  getCountry,
  getFreezeModelList,
  getFreezeBgList,
  getRating,
} from '../api'
import { mapGetters, mapMutations } from 'vuex'
const REGION_TYPE = 2,
  MODEL_TYPE = 3

export default {
  components: {
    CardEdit,
  },
  mixins: [mixin],
  name: 'create-form',
  props: ['permissions', 'customerDetail'],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      MODAL_WIDTH: 1000,
      SCORE_CARD_SCHEMA,
      formLayout: 'horizontal',
      checkboxList: [],
      filters: [],
      destroyOnClose: true,
      activeKey: [1, 2],
      basicButtonsShow: false, //企业基本信息按钮是否展现
      businessList: [], //业务类型
      regionOptionList: [], //大区 optionList
      modelOptionList: [], //业务模式
      modelList: [], //业务模式冻结
      syList: [], //业务类型冻结
    }
  },
  computed: {
    // 信用主管默认选择当前用户
    ...mapGetters('app', ['companyCode']),
    ...mapGetters('user', ['username']),
  },
  created() {
    this._getListCManager()
    this._getCountry()
    this._getBusinessList()
    //获取自定义评分卡
    getRating().then(({ data }) => {
      var list = []
      data.forEach(item => {
        list.push({ value: item.id, label: item.cardName })
      })
      this.SCORE_CARD_SCHEMA = this.SCORE_CARD_SCHEMA.concat(list)
      this.getScore()
    })
  },
  mounted() {
    this.query()
    this._getQueryBase()
  },
  methods: {
    //业务模式禁用
    handleModelFocus() {
      if (this.modelOptionList) {
        this.modelOptionList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.modelList) {
        this.modelOptionList.forEach(item => {
          this.modelList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },

    //业务类型禁用
    handleBgFocus() {
      if (this.businessList) {
        this.businessList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.syList) {
        this.businessList.forEach(item => {
          this.syList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //一定要刷新组件！！！！！！！！！！！！
      }
    },

    _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },

    ...mapMutations('app', [
      //'SET_COMPANYCODE',
      'SET_CUSTOMER_INFO',
      'SET_CUSTOMER_DETAIL',
    ]),
    async _getQueryBase() {
      this.handleBusiness(this.customerDetail.base.businessId)
    },
    async handleBusiness(value) {
      ;[REGION_TYPE, MODEL_TYPE].forEach(type => {
        this.fetchRegionList(value, type)
      })
    },
    query() {
      //企业基本信息内容
      for (let key in this.sourceDataBasic) {
        if (key === 'id') {
          this.sourceDataBasic[key] = this.$route.params.id
        } else {
          this.sourceDataBasic[key] = this.customerDetail.base[key]
        }
      }
    },
    //业务类型
    // _getBusinessList() {
    //   getBusinessList().then(({ data }) => {
    //     this.businessList = data
    //     this.BASIC_INFO_SCHEMA.business.optionList = data.map(item => {
    //       return { label: item.name, value: item.id }
    //     })
    //   })
    // },

    _getBusinessList() {
      getBusinessList().then(({ data }) => {
        this.businessList = data
        this._getFreezeBgList()
        // this.BASIC_INFO_SCHEMA.business.optionList = data.map(item => {
        //   return { label: item.name, value: item.id }
        // })
      })
    },

    changeBusiType(value) {
      this.setCardEditFormFieldsValue()
      ;[REGION_TYPE, MODEL_TYPE].forEach(type => {
        this.fetchRegionList(value, type)
      })
    },

    //大区｜模式 联动
    handleBusiTypeChange(value) {
      this.setCardEditFormFieldsValue()
      ;[REGION_TYPE, MODEL_TYPE].forEach(type => {
        this.fetchRegionList(value, type)
      })
    },
    setCardEditFormFieldsValue() {
      const list = ['region', 'model']
      list.forEach(key => {
        this.$refs.formBasic.setFormFieldsValue(key, '')
      })
    },
    // 筛选
    async fetchRegionList(pid, type) {
      try {
        const { data } = await getRegionList({ pid, type })
        this.setOptionListByType(type, data)
      } catch (error) {
        console.error(error)
      }
    },
    setOptionListByType(type, data) {
      switch (type) {
        case REGION_TYPE:
          this.regionOptionList = data
          return
        case MODEL_TYPE:
          this.modelOptionList = data
          this._getFreezeModelList()
          return
      }
    },
    _getFreezeModelList() {
      getFreezeModelList().then(({ data }) => {
        this.modelList = data
      })
    },

    // 信用主管 ｜ 商务主管 -fetch get optionList
    _getListCManager() {
      getListCManager().then(({ data }) => {
        this.BASIC_INFO_SCHEMA.businessSupervisor.optionList = this.BASIC_INFO_SCHEMA.creditManager.optionList = data.map(
          item => {
            return {
              label: item.name + '-' + item.username,
              value: item.username,
            }
          },
        )
      })
      // 信用主管默认选择当前用户
      this.sourceDataBasic.creditManager = this.username
    },
    // 获取国家
    async _getCountry() {
      const { data } = await getCountry()
      this.BASIC_INFO_SCHEMA.national.optionList = data.map(item => {
        return { label: item, value: item }
      })
    },
    // 默认评分卡
    getScore() {
      this.BASIC_INFO_SCHEMA.defaultScoreType.optionList = this.SCORE_CARD_SCHEMA
    },
    //编辑-企业基本信息
    editBasic() {
      this.basicButtonsShow = true
      for (let key in this.BASIC_INFO_SCHEMA) {
        this.BASIC_INFO_SCHEMA[key].disabled = false
      }
    },
    // 校验 - 企业基本信息
    async validateForm() {
      try {
        var values = await this.$refs.formBasic.handleSubmit()
        const passed = !!values
        if (passed) {
          values = {
            ...values,
            signDate: values.signDate.format('YYYY-MM-DD'),
            registerDate: values.registerDate.format('YYYY-MM-DD'),
            id: this.$route.params.id,
          }
          for (let key in this.sourceDataBasic) {
            this.sourceDataBasic[key] = values[key]
          }
          return this.sourceDataBasic
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 保存 - 企业基本信息
    async handleSubmitBasic() {
      var data = await this.validateForm()
      if (data) {
        addCuntomer(data).then(() => {
          // this.SET_COMPANYCODE(this.sourceDataBasic.code)
          this.$message.success('成功')
          this.basicButtonsShow = false
          this.$emit('hanleDetail')
          this.query()
          // disabled
          for (let key in this.BASIC_INFO_SCHEMA) {
            this.BASIC_INFO_SCHEMA[key].disabled = true
          }
        })
      }
    },
    // 取消 - 企业基本信息
    handleCancelBasic() {
      this.$refs.formBasic.handleReset()
      this.basicButtonsShow = false
      //disabled
      for (let key in this.BASIC_INFO_SCHEMA) {
        this.BASIC_INFO_SCHEMA[key].disabled = true
      }
    },
    _exportClient() {
      exportClient(this.$route.params.id)
    },
  },
}
</script>
<style lang="less" scoped>
.customer-baseinfo {
  .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  .margin-bottom-20 {
    margin-bottom: 20px;
  }
}
</style>
